<script>
  import Common from '../js/common.js';

  export let value = undefined;
  export let textAlign = undefined;

  const MESSAGE_APPEND_PART = 1;
  const MESSAGE_CODE_PART = 2;
  const MESSAGE_PREPEND_PART = 3;
  const CODE_MAX_LENGTH = 32;

  let message;

  $: if (value) {
    if (value.errors) {
      value.errors = value.errors.map(error => {
        error = Common.formatString(error.replace(/\n+/gm, ' '));

        const match = error.match(/(.+)"(.+)"(.+)/);

        if (match) {
          let code = match[MESSAGE_CODE_PART];

          if (code.length > CODE_MAX_LENGTH) {
            let i = 0;

            while (code[CODE_MAX_LENGTH - 1 - i] === ' ') i++;

            code = code.substring(0, CODE_MAX_LENGTH - i) + '&hellip;';
          }

          return `${match[MESSAGE_APPEND_PART]} "${code}" ${match[MESSAGE_PREPEND_PART]}`;
        } else {
          return error;
        }
      });

      message = value.errors.join('\n');
    } else {
      message = value.message;
    }
  }
</script>

{#if value}
  <div class='message-box'
    class:message-box-red={value.color === 'red'}
    class:message-box-yellow={value.color === 'yellow'}
    class:message-box-green={value.color === 'green'}
    class:message-box-blue={value.color === 'blue'}>

    <div class='message-box-text'
      class:message-box-text-center={textAlign === 'center'}
      class:message-box-text-right={textAlign === 'right'}>

      {@html Common.escapeHtml(message)}
    </div>
  </div>
{/if}

<style>
  .message-box {
    display: flex;
    align-items: center;

    width: calc(100% - 20px);
    min-height: 20px;

    padding: 10px;

    border-radius: 5px;

    font-weight: 550;

    line-height: 1.25;
  }

  .message-box-text {
    width: 100%;
  }

  .message-box-red {
    background: var(--red-1);
    color: var(--red-8);
  }

  :global(.message-box-red q) {
    background: var(--red-2);
    color: var(--red-9);
  }

  :global(.message-box-red p) {
    color: var(--red-2);
  }

  .message-box-yellow {
    background: var(--yellow-1);
    color: var(--yellow-8);
  }

  :global(.message-box-yellow q) {
    background: var(--yellow-2);
    color: var(--yellow-9);
  }

  :global(.message-box-yellow p) {
    color: var(--yellow-2);
  }

  .message-box-green {
    background: var(--green-1);
    color: var(--green-8);
  }

  :global(.message-box-green q) {
    background: var(--green-2);
    color: var(--green-9);
  }

  :global(.message-box-green p) {
    color: var(--green-2);
  }

  .message-box-blue {
    background: var(--blue-1);
    color: var(--blue-8);
  }

  :global(.message-box-blue q) {
    background: var(--blue-2);
    color: var(--blue-9);
  }

  :global(.message-box-blue p) {
    color: var(--blue-2);
  }

  .message-box-text-center {
    text-align: center;
  }

  .message-box-text-right {
    text-align: right;
  }

  :global(body.dark) .message-box-red {
    background: var(--grey-8);
    color: var(--red-3);
  }

  :global(body.dark) :global(.message-box-red q) {
    background: var(--grey-7);
    color: var(--red-2);
  }

  :global(body.dark) :global(.message-box-red p) {
    color: var(--grey-7);
  }

  :global(body.dark) .message-box-yellow {
    background: var(--grey-8);
    color: var(--yellow-3);
  }

  :global(body.dark) :global(.message-box-yellow q) {
    background: var(--grey-7);
    color: var(--yellow-2);
  }

  :global(body.dark) :global(.message-box-yellow p) {
    color: var(--grey-7);
  }

  :global(body.dark) .message-box-green {
    background: var(--grey-8);
    color: var(--green-3);
  }

  :global(body.dark) :global(.message-box-green q) {
    background: var(--grey-7);
    color: var(--green-2);
  }

  :global(body.dark) :global(.message-box-green p) {
    color: var(--grey-7);
  }

  :global(body.dark) .message-box-blue {
    background: var(--grey-8);
    color: var(--blue-3);
  }

  :global(body.dark) :global(.message-box-blue q) {
    background: var(--grey-7);
    color: var(--blue-2);
  }

  :global(body.dark) :global(.message-box-blue p) {
    color: var(--grey-7);
  }
</style>
